<div class="row mt-n2">
  <div class="col-4">
    <label for="chart_type" class="form-label">Chart Data Type</label>
    <ng-select id="chart_type" class="form-control p-0" bindLabel="name" bindValue="value" [searchable]="false" [clearable]="false" [searchable]="true" name="chartTypes" [(ngModel)]="chart_type" (ngModelChange)="changeWindowTime()" [items]="chartTypes" placeholder="Choose Chart Type"></ng-select>
  </div>
  <div class="col-4">
    <label for="windowTime" class="form-label">Window Time</label>
    <ng-select id="windowTime" class="form-control p-0" bindLabel="name" bindValue="value" [searchable]="false" [clearable]="false" [searchable]="true" name="windowTimes" [(ngModel)]="window_time" (ngModelChange)="changeWindowTime()" [items]="windowTimes" placeholder="Choose Window Time"></ng-select>
  </div>
</div>
<div class="heatmap" style="max-height: 250px;">
  @if (ready) {
    <ngx-charts-polar-chart class="dark"
      [view] = "view"
      [scheme]="colorScheme"
      [legend]="legend"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [legendPosition]="legendPosition"
      [xAxis]="xAxis"
      [yAxis]="yAxis"
      [yAxisMinScale]="100"
      [showSeriesOnHover]="false"
      [results]="chartData">
    </ngx-charts-polar-chart>
  }
  @if (!ready) {
    <div class="d-flex justify-content-center align-items-center" style="height: 250px;">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }
</div>